function parseVideo(url) {
    // - Supported YouTube URL formats:
    //   - http://www.youtube.com/watch?v=My2FRPA3Gf8
    //   - http://youtu.be/My2FRPA3Gf8
    //   - https://youtube.googleapis.com/v/My2FRPA3Gf8
    // - Supported Vimeo URL formats:
    //   - http://vimeo.com/25451551
    //   - http://player.vimeo.com/video/25451551
    // - Also supports relative URLs:
    //   - //player.vimeo.com/video/25451551

    url.match(/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(&\S+)?/);
    let type = '';

    if (RegExp.$3.indexOf('youtu') > -1) {
        type = 'youtube';
    } else if (RegExp.$3.indexOf('vimeo') > -1) {
        type = 'vimeo';
    }

    return {
        type,
        id: RegExp.$6,
    };
}

module.exports.create = function createVideo(url, width, height) {
    // Returns an iframe of the video with the specified URL.
    const videoObj = parseVideo(url);
    const iframeContainer = document.createElement('div');
    const iframe = document.createElement('iframe');
    iframeContainer.style.position = 'relative';
    iframeContainer.style.overflow = 'hidden';
    iframeContainer.style.paddingTop = '52.25%';
    iframeContainer.style.width = '800px';
    iframeContainer.style.maxWidth = '100%';
    iframe.setAttribute('width', width);
    iframe.setAttribute('height', height);
    iframe.setAttribute('frameborder', 0);
    iframe.style.position = 'absolute';
    iframe.style.top = 0;
    iframe.style.left = 0;
    iframe.style.width = '100%';
    iframe.style.height = '100%';
    iframe.style.border = 'none';
    if (videoObj.type === 'youtube') {
        iframe.setAttribute('src', `//www.youtube.com/embed/${videoObj.id}`);
    } else if (videoObj.type === 'vimeo') {
        iframe.setAttribute('src', `//player.vimeo.com/video/${videoObj.id}`);
    } else {
        return false;
    }
    iframeContainer.appendChild(iframe);
    return iframeContainer;
};

module.exports.makeEmbedUrl = function makeEmbedUrl(url) {
    const videoObj = parseVideo(url);
    if (videoObj.type === 'youtube') {
        return `//www.youtube.com/embed/${videoObj.id}`;
    } if (videoObj.type === 'vimeo') {
        return `//player.vimeo.com/video/${videoObj.id}`;
    }
    return false;
};
